module.exports = __webpack_public_path__ + "assets/img/17_1049_big.9e5f514d.jpg";